var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBoxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "url(#paint0_linear_614_30303)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7488 14.6163L20.9024 20.3874L14.5342 21.3158C13.3922 21.4814 12.9345 22.8893 13.7627 23.6957L18.37 28.1853L17.2803 34.5274C17.0841 35.6738 18.2915 36.5325 19.3028 35.9964L24.9998 33.0018L30.6968 35.9964C31.708 36.5281 32.9154 35.6738 32.7192 34.5274L31.6295 28.1853L36.2368 23.6957C37.065 22.8893 36.6073 21.4814 35.4653 21.3158L29.0971 20.3874L26.2507 14.6163C25.7408 13.5876 24.2631 13.5745 23.7488 14.6163Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_614_30303",
    x1: 0,
    y1: 50,
    x2: 50,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CE9D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBoxFilled);
export default __webpack_public_path__ + "static/media/star-box-filled.3e2e2acb4677671630311abd7df2b521.svg";
export { ForwardRef as ReactComponent };